import React from 'react'

import s from './Avatar.module.scss'

export const Avatar: React.FC<{ avatarUrl: string }> = ({ avatarUrl }) => {
  return <img src={avatarUrl} alt="Avatar" className={s.Avatar} />
}
